import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import SubHeader from '../components/SubHeader'
import MasterSwitchForm from '../forms/MasterSwitchForm'
import globals from '../globals'

const content = [
    {
        image: 'icon-anti-malware1.svg',
        title: 'Anti-malware',
        content: 'Helps protect you from malware such as viruses, crypto jacking, ransomware, key loggers, banking-trojans and more.'
    },
    {
        image: 'icon-anti-phishing1.svg',
        title: 'Anti-phishing',
        content: 'With 1 in 4 Australian experiencing identity theft at some time in their lives, Home Secure will help block sites that seek to steal your personal data and identity'
    },
    {
        image: 'icon-anti-virus1.svg',
        title: 'Anti-virus',
        content: 'Fights malicious viruses before they reach and take over your device or destroy your data and ruin more than just your day'
    },
    {
        image: 'icon-anti-bot1.svg',
        title: 'Anti-bot',
        content: 'Bad bots are right up there with the worst of the cyberthreats. They can log you key strokes, steal you passwords and steal your data. Block identified bots based on up-to-date threat intelligence'
    }
]

const ThreatProtection = (props) => {
    const handleChange = value => {
        globals.pushEvent(value ? 'HsThreatProtectionMasterToggleOn' : 'HsThreatProtectionMasterToggleOff')
        props.updateServiceDetails({ threatProtectionEnabled: value })
    }

    return (
        <div className='module'>
            <Heading title='Threat protection' />
            <ModuleWithLoader isLoaded hasError={false} className='p-4'>
                <div className='row mb-5'>
                    <div className='col-12 col-md-10 offset-md-1 text-center'>
                        <SubHeader
                            content='Home Secure fights cyberthreats at your internet connection, reducing their chance to get to your internet connected devices and get hold of your precious data. You can rest assured that every connected device in your household is more securely protected under the Home Secure shield.'
                            className='mb-5'
                        />
                        <MasterSwitchForm
                            serviceId={props.serviceId}
                            isEnabled={props.isEnabled}
                            postUrl='/api/postToggleThreatProtection'
                            title='Threat Protection Master Switch'
                            subTitle='Disabling will leave your internet connection more vulnerable to malicious cyberattacks'
                            type='Threat Protection'
                            handleChange={handleChange}
                        />
                    </div>
                </div>
                <div className='row text-center'>
                    <div className='col-12 mb-4'>
                        <h2 className='m-0 mb-3'>Stay safer online. Threat protection helps stop these internet baddies.</h2>
                    </div>
                    {content.map((item, key) => {
                        return (
                            <div key={key} className='col-12 col-lg-3 mb-3 mb-lg-0'>
                                <img src={`/images/home-secure/${item.image}`} alt='' width='70px' className='mb-2 mb-lg-3' />
                                <p className='m-0 mb-2 mb-lg-3 bold font-medium color-indigo'>{item.title}</p>
                                <p className='m-0 font-small lh'>{item.content}</p>
                            </div>
                        )
                    })}
                </div>
            </ModuleWithLoader>
        </div>
    )
}

ThreatProtection.propTypes = {
    serviceId: PropTypes.number.isRequired,
    isEnabled: PropTypes.bool,
    updateServiceDetails: PropTypes.func.isRequired
}

export default ThreatProtection



// WEBPACK FOOTER //
// ./resources/js/modules/ThreatProtection.js